import React, {
	createContext,
	ReactNode,
	useCallback,
	useContext,
	useEffect,
	useState,
} from 'react'

type AccordionState = {
	openIds: number[]
	toggle: (id: number) => void
	closeAll: () => void
	rerender: () => void
}
const initialCtx: AccordionState = {
	openIds: [],
	toggle: () => {},
	closeAll: () => {},
	rerender: () => {},
}
const accordionCtx = createContext(initialCtx)

const Provider = accordionCtx.Provider

export const useAccordion = () => useContext(accordionCtx)

type AccordionProviderProps = {
	children: ReactNode[]
	allowMultiOpen?: boolean
	initialId?: number
	initialOpenDelay?: number
}

export const AccordionProvider = ({
	children,
	allowMultiOpen,
	initialId,
	initialOpenDelay = 0,
}: AccordionProviderProps) => {
	const [openIds, setOpenIds] = useState<number[]>([])

	// eslint-disable-next-line @typescript-eslint/no-unused-vars
	const [_, initiateRerender] = useState(false)

	const toggle: AccordionState['toggle'] = useCallback(
		id =>
			setOpenIds(state => {
				const hasId = state.includes(id)

				if (hasId) {
					return state.filter(item => item !== id)
				} else if (allowMultiOpen) {
					return [...state, id]
				} else {
					return [id]
				}
			}),

		// eslint-disable-next-line react-hooks/exhaustive-deps
		[]
	)

	const closeAll = useCallback(() => {
		setOpenIds([])
	}, [])

	useEffect(() => {
		if (typeof initialId === 'number')
			initialOpenDelay
				? setTimeout(() => {
						toggle(initialId)
				  }, initialOpenDelay)
				: toggle(initialId)

		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [])

	const rerender = useCallback(() => initiateRerender(state => !state), [])

	return <Provider value={{ openIds, toggle, closeAll, rerender }}>{children}</Provider>
}
